(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hf-assortment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hf-assortment')) {
  customElements.define('hf-assortment', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.variant !== 'b' || this.dataset.ready) return;
      this.dataset.ready = 'true';
      const buttons = Array.from(this.querySelectorAll('[data-hf-filter]'));
      const panels = Array.from(this.querySelectorAll('[data-hf-group]'));
      const activate = (category) => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hfFilter === category)));
        panels.forEach(panel => { panel.hidden = category !== 'all' && panel.dataset.hfGroup !== category; });
      };
      buttons.forEach(button => button.addEventListener('click', () => activate(button.dataset.hfFilter)));
      const requested = new URLSearchParams(window.location.search).get('kategori');
      const initial = panels.some(panel => panel.dataset.hfGroup === requested) ? requested : 'sluk';
      activate(initial);
      if(window.location.hash.startsWith('#hf-kategori-')){
        requestAnimationFrame(() => {
          const destination = document.getElementById('hf-kategori-' + initial);
          if(destination) destination.scrollIntoView({block:'start'});
        });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-brand-navigation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hf-navigation')){
customElements.define('hf-navigation',class extends HTMLElement{
connectedCallback(){
if(this.dataset.ready)return;this.dataset.ready='true';
this.addEventListener('keydown',event=>{if(event.key==='Escape')this.querySelectorAll('details[open]').forEach(item=>{item.open=false;item.querySelector('summary').focus();});});
document.addEventListener('click',event=>{if(!this.contains(event.target))this.querySelectorAll('details[open]').forEach(item=>{item.open=false;});});
}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
